module.exports = __webpack_public_path__ + "img/product.9db8ac87.png";